document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-vehicle-finder]');
  if (!form) return;
  event.preventDefault();
  const selected = form.querySelector('select').value;
  if (!selected) return;
  const destination = new URL(selected, window.location.origin);
  if (destination.origin === window.location.origin && (destination.pathname.includes('/collections/') || /\/search\/?$/.test(destination.pathname))) {
    window.location.assign(destination.href);
  }
});

function updateVanxBackLink() {
  const backLink = document.querySelector('[data-collection-back]');
  if (!backLink) return;
  try {
    const previous = new URL(document.referrer);
    if (previous.origin === window.location.origin && /\/(collections|search)(\/|$)/.test(previous.pathname) && !previous.pathname.includes('/products/')) {
      backLink.href = previous.href;
    }
  } catch {}
}

const vanxFooterObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.18 })
  : null;

function initVanxFooterMotion(root = document) {
  if (!vanxFooterObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.querySelectorAll('[data-vanx-footer-wordmark]:not([data-motion-ready]):not([data-motion-disabled])').forEach((wordmark) => {
    wordmark.dataset.motionReady = '';
    vanxFooterObserver.observe(wordmark);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateVanxBackLink, { once: true });
  document.addEventListener('DOMContentLoaded', () => initVanxFooterMotion(), { once: true });
} else {
  updateVanxBackLink();
  initVanxFooterMotion();
}

document.addEventListener('shopify:section:load', (event) => initVanxFooterMotion(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-vanx-footer-wordmark]').forEach((wordmark) => vanxFooterObserver?.unobserve(wordmark));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || event.defaultPrevented || event.isComposing) return;
  const button = event.target.closest?.('.vanx-footer__localization .custom-select__btn');
  if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
  const selector = button.closest('country-selector, custom-select');
  if (!selector || selector.listboxOpen || typeof selector.showListbox !== 'function') return;
  event.preventDefault();
  selector.showListbox();
});
